<div class="asset-details-root">
  <div class="asset-details-header">
    <div class="row">
      <div class="asset-header-back-button col-auto" (click)="backClicked()">
        <button class="action-button">
          <svg
            width="15"
            height="12"
            viewBox="0 0 15 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.71 1.28906L1 5.99906L5.71 10.7091M1.5652 5.99906H13.4344"
              stroke="#17171A"
              stroke-opacity="0.9"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
      <div
        class="asset-header-info"
        [ngClass]="headerExpanded ? 'col-3' : 'col-4'"
      >
        <div class="row">
          <div class="col-12 header-title" *ngIf="!headerExpanded">
            <b>{{ "EDIT_INJECTION_SUBSTATION.IS_SLRN" | translate }}</b>
          </div>
          <div *ngIf="!headerExpanded" class="light-gray-text col-auto">
            {{ selectedSubstation.slrn }}
          </div>
          <!-- <div class="pill header-pill col-auto"
                        [ngClass]="{'light-gray-pill' : selectedMvPole.status == 'Pending',
                          'light-orange-pill' : selectedMvPole.status == 'Assigned' || selectedMvPole.status == 'Retagged', 
                          'green-success-pill': selectedMvPole.status == 'Complete', 'red-failure-pill': selectedMvPole.status == 'Rejected'}">
                        {{ selectedMvPole.status }} 
                        </div>  -->
        </div>
      </div>
      <div class="header-actions col">
        <button *ngIf="retagAllowed"
          class="btn asset-header-action-button"
          data-bs-toggle="modal"
          (click)="assetAssignType = AssetAssignType.Retagged"
          data-bs-target="#assignToFieldAgent"
        >
          {{ "COMMON.RETAG" | translate }}
        </button>
        <div class="recall-container position-relative d-inline-block">
          <button
            *ngIf="recallValidatedTask || recallAssignedTask"
            class="btn asset-header-action-button"
            (click)="showRecallMenu = !showRecallMenu"
          >
            {{ "COMMON.RECALL" | translate }}
          </button>
          <div
            *ngIf="showRecallMenu"
            class="recall-options shadow-sm"
            @slideToggle
          >
            <div
              *ngIf="recallAssignedTask"
              class="recall-type"
              [ngClass]="
                !recallAssignedAllowed
                  ? 'recall-type-disabled'
                  : 'recall-type-enabled'
              "
              (click)="recallAssignedAllowed ? recall() : null"
            >
              <span>{{ "COMMON.ASSIGNED_TASK" | translate }}</span>
            </div>
            <div
              *ngIf="recallValidatedTask"
              class="recall-type"
              [ngClass]="
                !recallValidatedAllowed
                  ? 'recall-type-disabled'
                  : 'recall-type-enabled'
              "
              (click)="recallValidatedAllowed ? recall() : null"
            >
              <span>{{ "COMMON.VALIDATED_TASK" | translate }}</span>
            </div>
          </div>
        </div>
        <button
          class="btn asset-header-action-button"
          data-bs-toggle="modal"
          data-bs-target="#updateStatus"
          [disabled]="true"
        >
          {{ "COMMON.UPDATE_STATUS" | translate }}
        </button>
        <button
          class="btn asset-header-action-button"
          data-bs-toggle="modal"
          data-bs-target="#auditReview"
          [disabled]="selectedSubstation.auditedStatus === 'Audited'"
        >
          {{ "COMMON.FIELD_AUDIT" | translate }}
        </button>
        <button
          class="btn asset-header-action-button"
          data-bs-toggle="modal"
          (click)="assetAssignType = AssetAssignType.Assigned"
          data-bs-target="#assignToFieldAgent"
        >
          {{ "COMMON.ASSIGN_AGENT" | translate }}
        </button>
        <button
          *ngIf="!editEnabled"
          class="btn asset-header-action-button"
          (click)="editEnabled = true"
        >
          {{ "COMMON.EDIT" | translate }}
        </button>
        <button
          *ngIf="editEnabled"
          class="btn asset-header-action-button asset-header-save-button"
          #openUpdateDescriptionModal
          data-bs-toggle="modal"
          data-bs-target="#history"
        >
          {{ "COMMON.SAVE" | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="asset-details-content">
    <div class="row">
      <!-- <div *ngIf="headerExpanded" class="col-3 expanded-header-info">
                <div class="collapse-header-button col">
                    <button class="action-button" (click)="headerExpanded = false">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.25 3.75H6.95C5.8299 3.75 5.26984 3.75 4.84202 3.96799C4.46569 4.15973 4.15973 4.46569 3.96799 4.84202C3.75 5.26984 3.75 5.8299 3.75 6.95V17.05C3.75 18.1701 3.75 18.7302 3.96799 19.158C4.15973 19.5343 4.46569 19.8403 4.84202 20.032C5.26984 20.25 5.8299 20.25 6.95 20.25H17.05C18.1701 20.25 18.7302 20.25 19.158 20.032C19.5343 19.8403 19.8403 19.5343 20.032 19.158C20.25 18.7302 20.25 18.1701 20.25 17.05V14.75M13.75 3.75H20.25M20.25 3.75V10.25M20.25 3.75L11 13"
                                stroke="#17171A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </button>
                </div>
            </div> -->
      <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
        <div
          class="asset-card col-11"
          [ngClass]="
            networkCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'
          "
        >
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-10">
              {{ "EDIT_INJECTION_SUBSTATION.NETWORK_INFO.TITLE" | translate }}
            </h2>
            <div class="collapse-arrow col-2">
              <button
                class="action-button"
                (click)="networkCardExpanded = true"
                *ngIf="!networkCardExpanded"
              >
                <svg
                  *ngIf="!networkCardExpanded"
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L5 5L9 1"
                    stroke="#17171A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <button
                class="action-button"
                (click)="networkCardExpanded = false"
                *ngIf="networkCardExpanded"
              >
                <svg
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 5L5 1L1 5"
                    stroke="#17171A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div
            *ngIf="networkCardExpanded"
            class="asset-card-content"
            @slideToggle
          >
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">
                {{ "EDIT_INJECTION_SUBSTATION.NETWORK_INFO.TS" | translate }}
              </div>
              <div class="col-7 asset-card-content-value">
                {{ selectedSubstation.tsName | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{
                  "EDIT_INJECTION_SUBSTATION.NETWORK_INFO.NUM_INC_FEEDERS"
                    | translate
                }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.numberOfIncomingFeeders | hasValue }}
              </div>
            </div>
            <div class="asset-card-info vertical-layout">
              <div class="asset-card-content-title">
                {{
                  "EDIT_INJECTION_SUBSTATION.NETWORK_INFO.INC_FEEDER_NAME"
                    | translate
                }}
              </div>
              <div
                class="asset-card-content-value"
                *ngFor="
                  let feederName of selectedSubstation.mainFeederNames;
                  let i = index
                "
              >
                {{ feederName | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="asset-card-content-title">
                {{
                  "EDIT_INJECTION_SUBSTATION.NETWORK_INFO.INC_FEEDER_NUMBER"
                    | translate
                }}
              </div>
              <div
                class="asset-card-content-value"
                *ngFor="
                  let feederNumber of selectedSubstation.mainFeederNumbers;
                  let i = index
                "
              >
                {{ feederNumber | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{
                  "EDIT_INJECTION_SUBSTATION.NETWORK_INFO.INJECTION_SS_NAME"
                    | translate
                }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.name | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{
                  "EDIT_INJECTION_SUBSTATION.NETWORK_INFO.INJECTION_SS_NUMBER"
                    | translate
                }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.number | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{
                  "EDIT_INJECTION_SUBSTATION.NETWORK_INFO.NUM_OUT_FEEDERS"
                    | translate
                }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.numberOfOutgoingFeeders | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="asset-card-content-title">
                {{
                  "EDIT_INJECTION_SUBSTATION.NETWORK_INFO.OUT_FEEDER_NAME"
                    | translate
                }}
              </div>
              <div
                class="asset-card-content-value"
                *ngFor="
                  let subFeederName of selectedSubstation.subFeederNames;
                  let i = index
                "
              >
                {{ subFeederName | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">
                {{ "COMMON.BU.SINGLE" | translate }}
              </div>
              <div class="col-7 asset-card-content-value">
                {{ selectedSubstation.regionName | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">
                {{ "COMMON.UT.SINGLE" | translate }}
              </div>
              <div class="col-7 asset-card-content-value">
                {{ selectedSubstation.areaName | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">
                {{ "MV_POLES.GEOLOCATION" | translate }}
              </div>
              <div class="col-6 asset-card-content-value">
                {{ selectedSubstation.latitude }},
                {{ selectedSubstation.longitude }}
              </div>
              <div
                class="geo-icon col-auto"
                (click)="setClickedLocation(undefined)"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  data-bs-toggle="modal"
                  data-bs-target="#showMap"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 0C8.30376 0 8.55479 0.225723 8.59452 0.518583L8.6 0.6L8.59925 2.03017C11.4343 2.31006 13.6899 4.56575 13.9706 7.40203L14 7.4H15.4C15.7314 7.4 16 7.66863 16 8C16 8.30376 15.7743 8.55479 15.4814 8.59452L15.4 8.6L13.9693 8.59923C13.6899 11.4343 11.4343 13.6899 8.59797 13.9706L8.6 14V15.4C8.6 15.7314 8.33137 16 8 16C7.69624 16 7.44521 15.7743 7.40548 15.4814L7.4 15.4L7.40077 13.9693C4.56575 13.6899 2.31006 11.4343 2.02942 8.59797L2 8.6H0.6C0.268629 8.6 0 8.33137 0 8C0 7.69624 0.225723 7.44521 0.518583 7.40548L0.6 7.4L2.03017 7.40075C2.31006 4.56575 4.56575 2.31006 7.40203 2.02942L7.4 2V0.6C7.4 0.268629 7.66863 0 8 0ZM8 3.2C5.34903 3.2 3.2 5.34903 3.2 8C3.2 10.651 5.34903 12.8 8 12.8C10.651 12.8 12.8 10.651 12.8 8C12.8 5.34903 10.651 3.2 8 3.2ZM8 4.8C9.76731 4.8 11.2 6.23269 11.2 8C11.2 9.76731 9.76731 11.2 8 11.2C6.23269 11.2 4.8 9.76731 4.8 8C4.8 6.23269 6.23269 4.8 8 4.8Z"
                    fill="var(--primary-color)"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div
          class="asset-card col-11"
          [ngClass]="
            userActivityExpanded
              ? 'asset-card-expanded'
              : 'asset-card-collapsed'
          "
        >
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-10">
              {{ "MV_POLES.USER_ACTIVITY" | translate }}
            </h2>
            <div class="collapse-arrow col-2">
              <button
                class="action-button"
                (click)="userActivityExpanded = true"
                *ngIf="!userActivityExpanded"
              >
                <svg
                  *ngIf="!userActivityExpanded"
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L5 5L9 1"
                    stroke="#17171A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <button
                class="action-button"
                (click)="userActivityExpanded = false"
                *ngIf="userActivityExpanded"
              >
                <svg
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 5L5 1L1 5"
                    stroke="#17171A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div
            *ngIf="userActivityExpanded"
            class="asset-card-content"
            @slideToggle
          >
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{ "COMMON.USER.TYPE.FIRST_CAPTURED" | translate }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.firstCapturedUser | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{ "COMMON.USER.TYPE.LAST_UPDATED" | translate }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.lastUpdatedUser | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{ "COMMON.CREATION_DATE" | translate }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.creationDate | date:'dd/MM/yyyy':'{{ timeZone


                }}' | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{ "COMMON.MBC_DETAILS.UPDATED_DATE" | translate }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.lastUpdateTime | date:'dd/MM/yyyy':'{{ timeZone


                }}' | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{ "COMMON.USER.TYPE.REASSIGNED" | translate }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.reassignedBy | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{ "COMMON.MBC_DETAILS.ASSIGNED" | translate }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.assignedBy | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{ "COMMON.VALIDATION_STATUS" | translate }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.dataQualityStatus | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{ "COMMON.USER.TYPE.VALIDATED" | translate }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.validatedBy | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{ "COMMON.DATE_TYPE.VALIDATED" | translate }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.validationDate | date:'dd/MM/yyyy':'{{ timeZone


                }}' | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{ "COMMON.MBC_DETAILS.AUDITED_STATUS" | translate }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.auditedStatus | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{ "COMMON.USER.TYPE.AUDITED" | translate }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.auditedBy | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{ "COMMON.MBC_DETAILS.AUDITED_DATE" | translate }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.auditedDateTime | date:'dd/MM/yyyy':'{{ timeZone


                }}' | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{ "COMMON.REVIEW_STATUS" | translate }}
              </div>
              <div class="col-5 asset-card-content-value">
                {{ selectedSubstation.reviewStatus | hasValue }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="asset-card col-11"
          [ngClass]="
            connectedFeedersMvPolesCardExpanded
              ? 'asset-card-expanded'
              : 'asset-card-collapsed'
          "
        >
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-10">
              {{
                "EDIT_INJECTION_SUBSTATION.CONNECTED_COUNT.TITLE" | translate
              }}
            </h2>
            <div class="collapse-arrow col-2">
              <button
                class="action-button"
                (click)="connectedFeedersMvPolesCardExpanded = true"
                *ngIf="!connectedFeedersMvPolesCardExpanded"
              >
                <svg
                  *ngIf="!connectedFeedersMvPolesCardExpanded"
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L5 5L9 1"
                    stroke="#17171A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <button
                class="action-button"
                (click)="connectedFeedersMvPolesCardExpanded = false"
                *ngIf="connectedFeedersMvPolesCardExpanded"
              >
                <svg
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 5L5 1L1 5"
                    stroke="#17171A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div
            *ngIf="connectedFeedersMvPolesCardExpanded"
            class="asset-card-content"
            @slideToggle
          >
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{
                  "EDIT_INJECTION_SUBSTATION.CONNECTED_COUNT.SUB_FEEDER"
                    | translate
                }}
              </div>
              <div class="col-5 asset-card-content-value">
                <span class="count-value">
                  {{
                    selectedSubstation.numberOfOutgoingFeeders
                      | number
                      | hasValue
                  }}
                </span>
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.39204 6.22407C5.63612 5.98 6.03185 5.98 6.27593 6.22407L9.02 8.96815C9.58952 9.53767 9.58952 10.461 9.02 11.0305L6.27593 13.7746C6.03185 14.0187 5.63612 14.0187 5.39204 13.7746C5.14796 13.5305 5.14796 13.1348 5.39204 12.8907L8.13612 10.1467C8.21748 10.0653 8.21748 9.93339 8.13612 9.85203L5.39204 7.10796C5.14796 6.86388 5.14796 6.46815 5.39204 6.22407ZM11.2254 6.22407C11.4695 5.98 11.8652 5.98 12.1093 6.22407L14.8533 8.96815C15.4229 9.53767 15.4229 10.461 14.8533 11.0305L12.1093 13.7746C11.8652 14.0187 11.4695 14.0187 11.2254 13.7746C10.9813 13.5305 10.9813 13.1348 11.2254 12.8907L13.9695 10.1467C14.0508 10.0653 14.0508 9.93339 13.9695 9.85203L11.2254 7.10796C10.9813 6.86388 10.9813 6.46815 11.2254 6.22407Z"
                    fill="var(--primary-color)"
                  />
                </svg>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{
                  "EDIT_INJECTION_SUBSTATION.CONNECTED_COUNT.MV_POLES"
                    | translate
                }}
              </div>
              <div class="col-5 asset-card-content-value">
                <span class="count-value">
                  {{ selectedSubstation.connectedMvPoles | number | hasValue }}
                </span>
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.39204 6.22407C5.63612 5.98 6.03185 5.98 6.27593 6.22407L9.02 8.96815C9.58952 9.53767 9.58952 10.461 9.02 11.0305L6.27593 13.7746C6.03185 14.0187 5.63612 14.0187 5.39204 13.7746C5.14796 13.5305 5.14796 13.1348 5.39204 12.8907L8.13612 10.1467C8.21748 10.0653 8.21748 9.93339 8.13612 9.85203L5.39204 7.10796C5.14796 6.86388 5.14796 6.46815 5.39204 6.22407ZM11.2254 6.22407C11.4695 5.98 11.8652 5.98 12.1093 6.22407L14.8533 8.96815C15.4229 9.53767 15.4229 10.461 14.8533 11.0305L12.1093 13.7746C11.8652 14.0187 11.4695 14.0187 11.2254 13.7746C10.9813 13.5305 10.9813 13.1348 11.2254 12.8907L13.9695 10.1467C14.0508 10.0653 14.0508 9.93339 13.9695 9.85203L11.2254 7.10796C10.9813 6.86388 10.9813 6.46815 11.2254 6.22407Z"
                    fill="var(--primary-color)"
                  />
                </svg>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{
                  "EDIT_INJECTION_SUBSTATION.CONNECTED_COUNT.LV_POLES"
                    | translate
                }}
              </div>
              <div class="col-5 asset-card-content-value">
                <span class="count-value">
                  {{ selectedSubstation.connectedLvPoles | number | hasValue }}
                </span>
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.39204 6.22407C5.63612 5.98 6.03185 5.98 6.27593 6.22407L9.02 8.96815C9.58952 9.53767 9.58952 10.461 9.02 11.0305L6.27593 13.7746C6.03185 14.0187 5.63612 14.0187 5.39204 13.7746C5.14796 13.5305 5.14796 13.1348 5.39204 12.8907L8.13612 10.1467C8.21748 10.0653 8.21748 9.93339 8.13612 9.85203L5.39204 7.10796C5.14796 6.86388 5.14796 6.46815 5.39204 6.22407ZM11.2254 6.22407C11.4695 5.98 11.8652 5.98 12.1093 6.22407L14.8533 8.96815C15.4229 9.53767 15.4229 10.461 14.8533 11.0305L12.1093 13.7746C11.8652 14.0187 11.4695 14.0187 11.2254 13.7746C10.9813 13.5305 10.9813 13.1348 11.2254 12.8907L13.9695 10.1467C14.0508 10.0653 14.0508 9.93339 13.9695 9.85203L11.2254 7.10796C10.9813 6.86388 10.9813 6.46815 11.2254 6.22407Z"
                    fill="var(--primary-color)"
                  />
                </svg>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">
                {{
                  "EDIT_INJECTION_SUBSTATION.CONNECTED_COUNT.DISTRIBUTION_TRANSFORMERS"
                    | translate
                }}
              </div>
              <div class="col-5 asset-card-content-value">
                <span class="count-value">
                  {{ selectedSubstation.connectedDts | number | hasValue }}
                </span>
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.39204 6.22407C5.63612 5.98 6.03185 5.98 6.27593 6.22407L9.02 8.96815C9.58952 9.53767 9.58952 10.461 9.02 11.0305L6.27593 13.7746C6.03185 14.0187 5.63612 14.0187 5.39204 13.7746C5.14796 13.5305 5.14796 13.1348 5.39204 12.8907L8.13612 10.1467C8.21748 10.0653 8.21748 9.93339 8.13612 9.85203L5.39204 7.10796C5.14796 6.86388 5.14796 6.46815 5.39204 6.22407ZM11.2254 6.22407C11.4695 5.98 11.8652 5.98 12.1093 6.22407L14.8533 8.96815C15.4229 9.53767 15.4229 10.461 14.8533 11.0305L12.1093 13.7746C11.8652 14.0187 11.4695 14.0187 11.2254 13.7746C10.9813 13.5305 10.9813 13.1348 11.2254 12.8907L13.9695 10.1467C14.0508 10.0653 14.0508 9.93339 13.9695 9.85203L11.2254 7.10796C10.9813 6.86388 10.9813 6.46815 11.2254 6.22407Z"
                    fill="var(--primary-color)"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
        <lib-section-instance-column
          [sections]="sectionInstances"
          columnAlign="center"
          (mapClicked)="setClickedLocation($event)"
        >
        </lib-section-instance-column>
      </div>
      <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
        <lib-section-instance-column
          [sections]="sectionInstances"
          columnAlign="right"
          (mapClicked)="setClickedLocation($event)"
        >
        </lib-section-instance-column>
      </div>
    </div>
  </div>
</div>

<div class="modal modalMap" id="showMap" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          #closeAddModal
          class="close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <lib-asset-map
          [setMapVisibility]="isMapVisible"
          [longitude]="longitude"
          [latitude]="latitude"
        >
        </lib-asset-map>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="assignToFieldAgent"
  tabindex="-1"
  aria-hidden="true"
  (hidden.bs.modal)="onModalAssignFade()"
  (shown.bs.modal)="onAssignModalShown()"
>
  <lib-assign-task-modal
    [areaId]="selectedSubstation.areaId"
    [assignTask]="assignTask"
    (idSelected)="selectFieldAgent($event)"
  >
  </lib-assign-task-modal>
</div>

<div class="modal fade" id="auditReview" tabindex="-1" aria-hidden="true">
  <lib-audit-review
    assetType="Substation"
    [assetId]="selectedSubstation.id"
    [areaId]="selectedSubstation.areaId"
  ></lib-audit-review>
</div>

<!-- <div class="modal" id="updateStatus" tabindex="-1" aria-hidden="true">
    <app-data-quality assetType="Substation" [assetId]="selectedSubstation.id"
        [areaId]="selectedSubstation.districtId"></app-data-quality>
</div> -->
